import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {AzoraSlider} from './slider';

const COMPONENT = [AzoraSlider]

@NgModule({
  imports: [
    
    CommonModule
  ],
  declarations: COMPONENT,
    exports: COMPONENT,
    entryComponents: COMPONENT
})
export class AzoraSliderModule { }
